export const CHARGE_PARTNER_EXPORT_ID = "Documento de carga - Pedidos por cliente";
export const CHARGE_PARTNER_TITLE = "Documento de carga - Pedidos por cliente";

export const DELIVERY_PARTNER_EXPORT_ID = "Carga - Entregas por cliente";
export const DELIVERY_PARTNER_TITLE = "Carga - Entregas por cliente";

export const CHARGE_PARTNER_PROPERTIES = {
  soldToCode: "Código de pagador",
  soldToName: "Nombre de pagador",
  shipToCode: "Código de receptor",
  shipToName: "Nombre de receptor",
  serial: "# de documento",
  className: "Clase de documento",
  materialCode: "Código de material",
  materialName: "Nombre de material",
  soldQuantity: "Cantidad Venta (UMV)",
  soldUnit: "UM Venta",
  baseQuantity: "Cantidad Base (UMB)",
  baseUnit: "UM Base",
  parallelQuantity: "Cantidad Paralela (UMP)",
  parallelUnit: "UM Paralela",
  finalPrice: "Precio final",
  discounts: "Descuentos",
  surcharges: "Recargos",
  subtotal: "Subtotal",
  taxes: "Impuestos",
  total: "Total",
};

export const CURRENCYFIELDS = [
  "subTotal",
  "totalDiscounts",
  "totalSurcharges",
  "subTotalBeforeTaxes",
  "totalTaxes",
  "total",
];

export const FORMATTER = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});